class TabsAndFaqLinks {
    constructor() {
        this.container = document.querySelector('[data-tabs-and-faq]')
        if (!this.container) return false

        this.tabContents = this.container.querySelectorAll('.wu-tabs__content--pane')
        this.tabButtons = this.container.querySelectorAll('.wu-tab')

        this.links = this.getLinks()

        this.init()
    }

    init() {
        this.listeners()
    }

    listeners() {
        for (let i = 0; i < this.links.length; i++) {
            this.links[i].addEventListener('click', e => {
                this.linkClickHandle(e)
            })
        }
    }

    linkClickHandle(e) {
        e.preventDefault()
        const id = e.target.getAttribute('href')
        const searchedItem = this.container.querySelector(id)
        if (!searchedItem) {
            document.querySelector(id).scrollIntoView()
        }
        this.moveToSearchedItem(searchedItem)
    }

    moveToSearchedItem(element) {
        for (let i = 0; i < this.getPath(element).length; i++) {
            for (let j = 0; j < this.tabContents.length; j++) {
                if (this.getPath(element)[i] === this.tabContents[j]) {
                    this.setActiveTab(j)
                    this.openAccordion(element)
                    element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                            inline: 'nearest'
                        }
                    )
                }
            }
        }
    }

    setActiveTab(index) {
        this.tabButtons[index].dispatchEvent(new Event('click'))
    }

    openAccordion(element) {
        const trigger = element.querySelector('.b-accordion__trigger')
        const content = element.querySelector('.b-accordion__content')

        trigger.classList.add('active')
        content.classList.add('active')
    }

    getPath(element) {
        let parents = []
        for (; element && element !== document; element = element.parentNode) {
            parents.push(element)
        }
        return parents
    }

    getLinks() {
        const allLinksInTheContainer = this.container.querySelectorAll('a')
        const links = []
        for (let i = 0; i < allLinksInTheContainer.length; i++) {
            const link = allLinksInTheContainer[i]
            if (link.getAttribute('href')[0] === '#') {
                links.push(link)
            }
        }
        return links
    }
}

new TabsAndFaqLinks()